import React, { useState, useRef, useEffect } from 'react';
import styles from './ExpandableText.module.scss';
import { sanitizeHtml } from '../../../../../Utils/sanitize';

const TRUNCATED_HEIGHT = '5.2em';

const ExpandableText = ({ htmlContent, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(TRUNCATED_HEIGHT);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight + 'px');
    }
  }, [htmlContent]);

  if (htmlContent.length <= maxLength) {
    return <div className={styles.description} dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlContent) }} />;
  }

  return (
    <div className={styles.expandableContainer}>
      <div
        ref={contentRef}
        className={`${styles.description} ${!isExpanded ? styles.truncated : ''}`}
        style={{ maxHeight: isExpanded ? contentHeight : TRUNCATED_HEIGHT }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlContent) }}
      />
      <button onClick={() => setIsExpanded(!isExpanded)} className={styles.toggleButton}>
        {isExpanded ? 'Read Less' : 'Read More'}
      </button>
    </div>
  );
};

export default ExpandableText;